module.exports = __webpack_public_path__ + "static/img/katun12.d7713b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/katun12.jpg
// module id = SBLx
// module chunks = 0